import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import icClose from '@iconify/icons-ic/twotone-close';
import icWarning from '@iconify/icons-ic/twotone-warning';
import icPeople from '@iconify/icons-ic/twotone-people';
import icBusiness from '@iconify/icons-ic/twotone-business';
import { PhoneNumberModel } from '../../../../../../core/models/phone-number.model';

export interface ContactReplacementData {
  conflictingContacts: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumbers: PhoneNumberModel[];
    establishments: {
      _id: string;
      label: string;
    }[];
    totalEstablishments: number;
  }[];
  summary: {
    totalContactsToReplace: number;
    totalEstablishmentsImpacted: number;
  };
  newContact: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumbers: PhoneNumberModel[];
  };
}

@Component({
  selector: 'vex-supplier-contact-replacement-modal',
  templateUrl: './supplier-contact-replacement-modal.component.html',
  styleUrls: ['./supplier-contact-replacement-modal.component.scss'],
})
export class SupplierContactReplacementModalComponent {
  icClose = icClose;
  icWarning = icWarning;
  icPeople = icPeople;
  icBusiness = icBusiness;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContactReplacementData,
    public dialogRef: MatDialogRef<SupplierContactReplacementModalComponent>,
  ) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  formatPhoneNumbers(phoneNumbers: PhoneNumberModel[]): string {
    if (!phoneNumbers || phoneNumbers.length === 0) {
      return 'Aucun téléphone';
    }
    return phoneNumbers.map(p => {
      const prefix = p.prefix?.dialCode ? `(+${p.prefix.dialCode}) ` : '';
      return `${prefix}${p.phoneNumber}`;
    }).join(', ');
  }

  getContactFullName(contact: any): string {
    return `${contact.firstName} ${contact.lastName}`;
  }
}
